import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Tv } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { Production, Classement, Qualite, Alertes, Presence } from "./Equipe";
import { Performance, Objectifs, Carte, Integration, Retours } from "./Equipe2";
import { Planning, FormChallenge, RapportJour } from "./Formulaires";

export const AccueilResponsable = () => {
  const [d, setD] = useState(null);
  const charger = useCallback(() => api.get("/tableaux/responsable").then((r) => setD(r.data)).catch((x) => toast.error(messageErreur(x))), []);
  useEffect(() => { charger(); }, [charger]);
  if (!d) return <p className="at-muted text-sm mb-6" data-testid="team-home-loading">Chargement du plateau…</p>;
  const supprimer = async (id) => { try { await api.delete(`/challenges/${id}`); charger(); } catch (x) { toast.error(messageErreur(x)); } };
  return (
    <div className="space-y-4 mb-6" data-testid="team-home">
      <Link to="/mur" className="at-btn at-btn-ghost w-full sm:w-auto" data-testid="team-wall-link"><Tv size={16} />Mur d'équipe (télé du plateau)</Link>
      <div className="grid lg:grid-cols-2 gap-4">
        <Production p={d.production} />
        <Alertes liste={d.alertes} />
        <Classement liste={d.classement} />
        <Presence liste={d.presence} heures={d.heures} meilleures={d.meilleures_heures} />
        <Qualite liste={d.qualite} />
        <Objectifs liste={d.objectifs} challenges={d.challenges} formulaire={{ supprimer, element: <FormChallenge onMaj={charger} /> }} />
        <Performance p={d.performance} />
        <Carte liste={d.carte} />
        <Retours liste={d.retours} />
        <Integration liste={d.integration} />
        <Planning liste={d.planning} agents={d.presence} onMaj={charger} />
        <RapportJour r={d.rapport} onMaj={charger} />
      </div>
    </div>
  );
};
